import { render, staticRenderFns } from "./CloseFormRegistrationsAction.vue?vue&type=template&id=37460189"
import script from "./CloseFormRegistrationsAction.vue?vue&type=script&lang=js"
export * from "./CloseFormRegistrationsAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports